module.exports = [
	{
		"description": "Removed <code>client.resource_servers</code> from documented sample response.",
		"old": false,
		"type": "Changed",
		"module": "Management API",
		"exclusive": "",
		"team": [
			"hugo.arregui@auth0.com"
		],
		"publishedAt": "2017-05-29"
	},
	{
		"description": "<ul><li>Added support to query by identifier on <code>PATCH / GET / DELETE api/v2/resource-servers</code> endpoints.</li><li>Added pagination to <code>GET api/v2/clients</code> endpoint.</li></ul>",
		"old": false,
		"type": "Added",
		"module": "Management API",
		"exclusive": "",
		"team": [
			"hugo.arregui@auth0.com"
		],
		"publishedAt": "2017-05-29"
	},
	{
		"description": "<ul><li>Officially dropped support for Microsoft’s Internet Explorer 10.</li><li>Fixed issue in the APIs section’s Test tab: changing languages in the code viewers now change the language properly.</li><li>Fixed visual issue with code editors backgrounds in the User Details section when using Chrome in Windows 10.</li><li>Fixed overflowing of text when users have huge strings without spaces or breaks in their External Attributes Object.</li><li>Fixed issue with Delete Account prompt showing a default domain name instead of the correct domain for that account.</li><li>Fixed issue with positioning for SAML connections list pagination controls.</li><li>Fixed issue when uploading custom logo in Tenant Settings section would crash the browser.</li><li>Fixed issue with users with special characters in their IDs that could not be seen in the dashboard.</li><li>Improved UI for User Identities in User Details: replaced the old JSON viewer for a better-looking code editor.</li><li>Fixed SAMLP default mappings example to avoid getting parsing errors by default.</li><li>Now the API section is displayed by default.</li></ul>",
		"old": false,
		"type": "fixed",
		"module": "Management Dashboard",
		"exclusive": "",
		"team": [
			"tomas.chernov@auth0.com"
		],
		"publishedAt": "2017-05-11"
	},
	{
		"description": "<p>New connection for PayPal Sandbox applications, it can be found in <a href='https://manage.auth0.com/#/connections/social'>Social Connections in dashboard</a></p>",
		"old": false,
		"type": "added",
		"module": "Authentication",
		"exclusive": "",
		"team": [
			"eduardo.diaz@auth0.com"
		],
		"publishedAt": "2017-05-09"
	},
	{
		"description": "<p>Server-side resource-owner password flows that use brute-force detection can now prevent erroneous blocking scenarios by utilizing the 'auth0-forwarded-for' header. See the <a href='https://auth0.com/docs/api-auth/tutorials/using-resource-owner-password-from-server-side'>documentation</a> for more details.</p>",
		"old": false,
		"type": "added",
		"module": "API Authorization",
		"exclusive": "",
		"team": [
			"damian.fortuna@auth0.com"
		],
		"publishedAt": "2017-04-12"
	},
	{
		"description": "<ul><li>Fixed outdated link in Sharepoint SSO Integration tutorial page.</li><li>Improved error message in the <a href='https://manage.auth0.com/#/emails'>Email Templates section</a> when the <code>from</code> field is not properly filled.</li><li>Fixed UI for form validations so they don’t linger after a successful submission of the form.</li><li>Added <code>read:user_idp_tokens</code> to available scopes for the <a href='https://manage.auth0.com/#/apis/management/scopes'>Management API</a>.</li></ul>",
		"old": false,
		"type": "fixed",
		"module": "Management Dashboard",
		"exclusive": "",
		"team": [
			"tomas.chernov@auth0.com"
		],
		"publishedAt": "2017-04-05"
	},
	{
		"description": "<p>Rules will now run when calling <code>oauth/token</code> with <code>grant_type: password</code> or <code>grant_type: refresh_token</code>. For more information, check out <a href='https://auth0.com/docs/migrations#password-and-refresh-token-exchange-rules-migration-notice'>our documentation</a>.</p>",
		"old": false,
		"type": "added",
		"module": "Authentication",
		"exclusive": "cloud",
		"team": [
			"samuel.judson@auth0.com"
		],
		"publishedAt": "2017-02-23"
	},
	{
		"description": "<p><code>user.last_password_reset</code> will now be set immediately when the user changes their password, instead of waiting for the next login.</p>",
		"old": false,
		"type": "added",
		"module": "Authentication",
		"exclusive": "cloud",
		"team": [
			"german@auth0.com"
		],
		"publishedAt": "2017-03-14"
	},
	{
		"description": "<p>Added support for <code>read:user</code> scope when using Github social connections</p>",
		"old": false,
		"type": "added",
		"module": "Authentication",
		"exclusive": "cloud",
		"team": [
			"eduardo.diaz@auth0.com"
		],
		"publishedAt": "2017-03-08"
	},
	{
		"description": "<p>Added multifactor authentication capabilities to the oauth/token endpoint. See the <a href='https://auth0.com/docs/api-auth/tutorials/multifactor-resource-owner-password'>documentation</a> for more details.</p>",
		"old": false,
		"type": "added",
		"module": "API Authorization",
		"exclusive": "",
		"team": [
			"damian.fortuna@auth0.com",
			"jose.luis.diaz@auth0.com",
			"fredrik.liljegren@auth0.com"
		],
		"publishedAt": "2017-04-05"
	},
	{
		"description": "<ul><li>Added functionality to filter-as-you-type the tenant list in the tenant dropdown for tenant lists with more than 10 tenants in them.</li><li>Updated UI for the &lt;app_metadata&gt; and &lt;user_metadata&gt; properties, in the User Details section, to feature a full-featured editor with code folding.</li><li>Renamed the “Setup” button in SAMLP connections list to “Setup Instructions”.</li><li>Fixed a series of issues with dashboard invitees:<ul><li>Prevent non-owners from entering the “create SSO Integrations” route.</li><li>Prevent non-owners from entering the Logs section.</li><li>Prevent non-owners from entering the account sub-sections (Admins, Payment, etc.).</li></ul></li><li>Updated UI for Dashboard Admins to fix XSS vulnerability when deleting dashboard admins and relocated the row to add an admin to always be on top of the list to avoid scrolling in long lists.</li><li>Updated UI for User Details to account for long &lt;name&gt; and &lt;username&gt; properties by truncating them.</li><li>Added the possibility to save Sharepoint SSO Integrations &lt;external URLs&gt; as a comma-separated list to set multiple of them.</li></ul>",
		"old": false,
		"type": "fixed",
		"module": "Management Dashboard",
		"exclusive": "",
		"team": [
			"tomas.chernov@auth0.com"
		],
		"publishedAt": "2017-03-10"
	},
	{
		"description": "<p>Updated the UI for the <a href='https://manage.auth0.com/#/apis/management/explorer'>API Explorer tab</a> to be able to configure the token expiration for the Management API.</p>",
		"old": false,
		"type": "added",
		"module": "Management API",
		"exclusive": "cloud",
		"team": [
			"tomas.chernov@auth0.com"
		],
		"publishedAt": "2017-02-25"
	},
	{
		"description": "<p>Added a new property <description> for Clients, a free-text field to describe the client’s purpose.</p>",
		"old": false,
		"type": "added",
		"module": "Clients",
		"exclusive": "",
		"team": [
			"tomas.chernov@auth0.com"
		],
		"publishedAt": "2017-02-22"
	},
	{
		"description": "<p>Guardian Authenticator for Android is now capable of scanning and managing any generic TOTP key.</p>",
		"old": false,
		"type": "added",
		"module": "MFA",
		"exclusive": "cloud",
		"team": [
			"nicolas.ulrich@auth0.com"
		],
		"publishedAt": "2017-02-22"
	},
	{
		"description": "<p>Released new <a href='https://github.com/auth0/Lock.swift'>Lock for iOS</a> version written in Swift and <a href='https://github.com/auth0/Lock.swift/blob/master/MIGRATION.md'>migration guide</a> to help the transition.</p>",
		"old": false,
		"type": "added",
		"module": "SDKs",
		"exclusive": "",
		"team": [
			"hernan@auth0.com",
			"martin.walsh@auth0.com"
		],
		"publishedAt": "2017-02-16"
	},
	{
		"description": "<p>Added enhancements to SAML Single Logout to conform to the Single Logout Profile specification. With these enhancements, all SAML Service Providers you have configured for logout will be sent a <code>LogoutRequest</code> to the <code>logout.callback</code> URL you have configured in the SAML Add-on. If your Service Provider does not support Single Logout, you can set <code>logout.slo_enabled: false</code> in your SAML Add-on configuration. For more information, check out our <a href='https://auth0.com/docs/logout#saml-logout'>Logout documentation</a> and <a href='https://auth0.com/docs/protocols/saml/saml-configuration#logout'>SAML configuration documentation</a>.</p>",
		"old": false,
		"type": "added",
		"module": "Authentication",
		"exclusive": "cloud",
		"team": [
			"hernan.tierno@auth0.com",
			"marcos.castany@auth0.com"
		],
		"publishedAt": "2017-01-16"
	},
	{
		"description": "<p>Published <a href='https://github.com/auth0/auth0.js/releases/tag/v8.0.0'>auth0.js v8</a> and <a href='https://auth0.com/docs/libraries/auth0js/migration-guide'>migration guide</a> to help the transition.</p>",
		"old": false,
		"type": "added",
		"module": "SDKs",
		"exclusive": "",
		"team": [
			"german@auth0.com",
			"hernan@auth0.com"
		],
		"publishedAt": "2017-01-03"
	},
	{
		"description": "<p>Consolidated brute-force detection into a single Shield.</p>",
		"old": false,
		"type": "changed",
		"module": "Anomaly Detection",
		"exclusive": "cloud",
		"team": [
			"jose.luis.diaz@auth0.com"
		],
		"publishedAt": "2016-12-26"
	},
	{
		"description": "<p>Added client flag to disable SSO (<code>sso_disabled</code>) which can be set using the Management API. When this flag is set to <code>true</code>, an Auth0 session will not be created for any authentication using that client.</p>",
		"old": false,
		"type": "added",
		"module": "Authentication",
		"exclusive": "cloud",
		"team": [
			"hernan.tierno@auth0.com",
			"hugo.arregui@auth0.com"
		],
		"publishedAt": "2016-12-02"
	},
	{
		"description": "<p>It is now possible to pre-enroll users into Guardian via an enrollment email. See <a href='https://auth0.com/docs/multifactor-authentication/administrator/guardian-enrollment-email'>here</a> for more information.</p>",
		"old": false,
		"type": "added",
		"module": "MFA",
		"exclusive": "cloud",
		"team": [
			"jose.luis.diaz@auth0.com"
		],
		"publishedAt": "2016-12-02"
	},
	{
		"description": "<p>Published new mobile SDKs for iOS (<a href='https://github.com/auth0/Guardian.swift'>Guardian.swift</a>) and Android (<a href='https://github.com/auth0/Guardian.Android'>Guardian.Android</a>) to make it simple to build custom Guardian mobile applications.</p>",
		"old": false,
		"type": "added",
		"module": "MFA",
		"exclusive": "cloud",
		"team": [
			"nicolas.ulrich@auth0.com",
			"hernan@auth0.com"
		],
		"publishedAt": "2016-11-25"
	},
	{
		"description": "<p>nonce parameter is now mandatory if you are using implicit grant flow</p>",
		"old": false,
		"type": "added",
		"module": "Authentication",
		"exclusive": "",
		"team": [
			"samuel.judson@auth0.com"
		],
		"publishedAt": "2016-11-18"
	},
	{
		"description": "<p>Added <code>expires_in</code> to oauth/token endpoint</p>",
		"old": false,
		"type": "added",
		"module": "API Authorization",
		"exclusive": "",
		"team": [
			"hernan.tierno@auth0.com"
		],
		"publishedAt": "2016-12-01"
	},
	{
		"description": "<p>Upgraded Auth0 hosted login page to Lock 10.7.</p>",
		"old": false,
		"type": "changed",
		"module": "Authentication",
		"exclusive": "",
		"team": [
			"iaco@auth0.com"
		],
		"publishedAt": "2016-12-01"
	},
	{
		"description": "<p>Double quotes in assertions caused invalid SAML signature.</p>",
		"old": false,
		"type": "fixed",
		"module": "Authentication",
		"exclusive": "",
		"team": [
			"marcos.castany@auth0.com"
		],
		"publishedAt": "2016-10-26"
	},
	{
		"description": "<p>Verification email does not display given_name attribute for custom DB.</p>",
		"old": false,
		"type": "fixed",
		"module": "Connections",
		"exclusive": "",
		"team": [
			"eduardo.diaz@auth0.com",
			"hernan.tierno@auth0.com"
		],
		"publishedAt": "2016-10-24"
	},
	{
		"description": "<p>Released new version of Lock for Web with several bugfixes and improvements including support for custom OAuth2 connections. See <a href='https://github.com/auth0/lock/blob/master/CHANGELOG.md'>Lock's changelog</a> for more information.</p>",
		"old": false,
		"type": "added",
		"module": "Lock",
		"exclusive": "",
		"team": [
			"german@auth0.com",
			"benjamin@auth0.com",
			"cristian@auth0.com"
		],
		"publishedAt": "2016-11-02"
	},
	{
		"description": "<p>Released new major version of Lock for Android with redesigned UI and new features like custom OAuth2 connections support, password policy, etc. See the <a href='https://auth0.com/docs/libraries/lock-android'>docs</a> for more information.</p>",
		"old": false,
		"type": "added",
		"module": "Lock",
		"exclusive": "",
		"team": [
			"luciano.balmaceda@auth0.com"
		],
		"publishedAt": "2016-09-21"
	},
	{
		"description": "<p>Published new mobile SDKs for iOS (<a href='https://github.com/auth0/Auth0.swift'>Auth0.swift</a>) and Android (<a href='https://github.com/auth0/Auth0.Android'>Auth0.Android</a>) to make it simple to build custom login screens using Auth0.</p>",
		"old": false,
		"type": "added",
		"module": "SDKs",
		"exclusive": "",
		"team": [
			"hernan@auth0.com",
			"luciano.balmaceda@auth0.com"
		],
		"publishedAt": "2016-10-06"
	},
	{
		"description": "<p>Added new Tenant settings for:<ul><li><code>default_audience</code> - Specifies the audience that clients will receive as a default if one isn't explicitly requested</li><li><code>default_directory</code> - Specifies a default directory connection to use when using <code>password grant</code> flow</li></ul></p>",
		"old": false,
		"type": "added",
		"module": "Settings",
		"exclusive": "",
		"team": [
			"tomas.chernov@auth0.com",
			"martin.cabral@auth0.com"
		],
		"publishedAt": "2016-10-26"
	},
	{
		"description": "<p>Added paging to Database Connctions page to support large volume of connections</p>",
		"old": false,
		"type": "added",
		"module": "Connections",
		"exclusive": "",
		"team": [
			"tomas.chernov@auth0.com",
			"hugo.arregui@auth0.com",
			"yenkel@auth0.com"
		],
		"publishedAt": "2016-10-15"
	},
	{
		"description": "<p>Release of the UI-less client libraries for Guardian, allowing users to build custom Guardian widgets. See the library <a href='https://github.com/auth0/auth0-guardian.js'>here</a> for more information</p>",
		"old": false,
		"type": "added",
		"module": "MFA",
		"exclusive": "cloud",
		"team": [
			"damian.fortuna@auth0.com"
		],
		"publishedAt": "2016-10-31"
	},
	{
		"description": "<p>It is now possible to disable automatic SMS and email notifications during Passwordless user creation. See the <a href='https://auth0.com/docs/api/management/v2#!/Users/post_users'>docs</a> for more information.</p>",
		"old": false,
		"type": "added",
		"module": "API",
		"exclusive": "",
		"team": [
			"eduardo.diaz@auth0.com"
		],
		"publishedAt": "2016-10-05"
	},
	{
		"description": "<p>When a user hits the rate limit for the <code>delegation</code> endpoint, log entries will now be visible in the tenant logs.</p>",
		"old": false,
		"type": "added",
		"module": "Authentication",
		"exclusive": "",
		"team": [
			"hernan.tierno@auth0.com"
		],
		"publishedAt": "2016-09-26"
	},
	{
		"description": "<p>SSO Session Timeout can be customized in Tenant Settings > Advanced. This allows you to specify how long the SSO Cookie is valid.</p>",
		"old": false,
		"type": "added",
		"module": "SSO",
		"exclusive": "",
		"team": [
			"iaco@auth0.com",
			"hugo.arregui@auth0.com",
			"tomas.chernov@auth0.com"
		],
		"publishedAt": "2016-09-22"
	},
	{
		"description": "<p>You can now opt-in to preview the new OAuth2aaS pipeline in Account Settings > Advanced. This enables support for Advanced API Authorization scenarios including user consent.</p>",
		"old": false,
		"type": "added",
		"module": "OAuth2",
		"exclusive": "",
		"team": [
			"iaco@auth0.com",
			"martin.cabral@auth0.com"
		],
		"publishedAt": "2016-09-21"
	},
	{
		"description": "<p>Database Connections now allow customizing the minimum and maximum length for usernames, up to 128 characters. This only applies if <code>Require Username</code> is on.</p><p><img src=\"https://cdn2.auth0.com/website/changelog/username-length.png\" alt=\"username length\"></p>",
		"old": false,
		"type": "added",
		"module": "Connections",
		"exclusive": "",
		"team": [
			"tomas.chernov@auth0.com",
			"eduardo.diaz@auth0.com",
			"hernan@auth0.com",
			"hugo.arregui@auth0.com"
		],
		"publishedAt": "2016-09-19"
	},
	{
		"description": "<p>Renamed the Delete All Users endpoint from <code>DELETE /api/v2/users</code> to <code>DELETE /api/v2/allusers</code> to avoid accidental deletion of users.</p>",
		"old": false,
		"type": "changed",
		"module": "API",
		"exclusive": "",
		"team": [
			"hugo.arregui@auth0.com"
		],
		"publishedAt": "2016-09-13"
	},
	{
		"description": "<p>Fixed error when custom DB scripts are set to <code>null</code></p>",
		"old": false,
		"type": "fixed",
		"module": "Authentication",
		"exclusive": "",
		"team": [
			"hernan.tierno@auth0.com"
		],
		"publishedAt": "2016-09-21"
	},
	{
		"description": "<p>Add <code>oid</code> claim to Azure AD user profiles</p>",
		"old": false,
		"type": "added",
		"module": "Enterprise Connections",
		"exclusive": "",
		"team": [
			"hernan.tierno@auth0.com"
		],
		"publishedAt": "2016-09-07"
	},
	{
		"description": "<p>Auth0 Guardian now allows users to choose to 'remember this browser' and not be prompted for MFA for 30 days from a known system.</p>",
		"old": false,
		"type": "added",
		"module": "MFA",
		"exclusive": "cloud",
		"team": [
			"fredrik.liljegren@auth0.com"
		],
		"publishedAt": "2016-10-05"
	},
	{
		"description": "<p>Releasing password breach detection, which protects Auth0 users in case their password is leaked via a breach at a different provider. Auth0 monitors announcments of breaches from other providers, and checks Auth0 users against the list of leaked accounts. In case of a match, the user will be prevented from logging in until their password is reset.</p>",
		"old": false,
		"type": "added",
		"module": "Password Breach Detection",
		"exclusive": "cloud",
		"team": [
			"jose@auth0.com"
		],
		"publishedAt": "2016-08-24"
	},
	{
		"description": "<p>Auth0 Guardian is now officially released -- a new and convenient way to perform multifactor authentication for logins. Guardian features 'push-notifications' as well as other standard authentication flows. See our full announcement <a href='https://auth0.com/blog/announcing-Auth0-Guardian-a-new-way-to-login'>here</a>.</p>",
		"old": false,
		"type": "added",
		"module": "MFA",
		"exclusive": "cloud",
		"team": [
			"damian.fortuna@auth0.com",
			"nicolas.ulrich@auth0.com",
			"hernan@auth0.com"
		],
		"publishedAt": "2016-08-25"
	},
	{
		"description": "<p>Added the ability to regenerate Guardian recovery codes. Please visit our <a href='https://auth0.com/docs/api/management/v2#!/Users/post_recovery_code_regeneration'>documentation</a> for details.</p>",
		"old": false,
		"type": "added",
		"module": "MFA",
		"exclusive": "cloud",
		"team": [
			"fredrik.liljegren@auth0.com"
		],
		"publishedAt": "2016-08-29"
	},
	{
		"description": "<p>The API now has the ability to manage Guardian configuration. Please visit our <a href='https://auth0.com/docs/api/management/v2#!/Guardian/'>documentation</a> for full details.</p>",
		"old": false,
		"type": "added",
		"module": "MFA",
		"exclusive": "cloud",
		"team": [
			"damian.fortuna@auth0.com"
		],
		"publishedAt": "2016-08-05"
	},
	{
		"description": "<p>SAML Response is now displayed in Tenant Logs when Debug Mode is enabled in the SAML Connection.</p>",
		"old": false,
		"type": "added",
		"module": "Logs",
		"exclusive": "",
		"team": [
			"marcos.castany@auth0.com"
		],
		"publishedAt": "2016-09-02"
	},
	{
		"description": "<p>Update response from Device Credentials endpoint to include <code>type</code> and <code>user_id</code>.</p>",
		"old": false,
		"type": "added",
		"module": "API",
		"exclusive": "",
		"team": [
			"hugo.arregui@auth0.com"
		],
		"publishedAt": "2016-09-05"
	},
	{
		"description": "<p>Added ability to specify Client Logo on the client API</p>",
		"old": false,
		"type": "added",
		"module": "API",
		"exclusive": "",
		"team": [
			"german@auth0.com"
		],
		"publishedAt": "2016-08-24"
	},
	{
		"description": "<p>Guardian template is now customizable via the Hosted Pages section.</p>",
		"old": false,
		"type": "added",
		"module": "MFA",
		"exclusive": "cloud",
		"team": [
			"damian.fortuna@auth0.com"
		],
		"publishedAt": "2016-08-17"
	},
	{
		"description": "<p>Fixed issue with Account Un-Linking where the secondary account would not show up in the Users list after being Un-Liked. Now, when Un-Linking two linked accounts, the secondary account will be restored and visible in Users.</p>",
		"old": false,
		"type": "fixed",
		"module": "Logs",
		"exclusive": "",
		"team": [
			"hugo.arregui@auth0.com"
		],
		"publishedAt": "2016-08-09"
	},
	{
		"description": "<p>Bulk Import API has been upgraded with the following changes: <ul> <li>Added option to specify if the operation should should insert or upsert</li> <li>Added <code>external_id</code> parameter. The value is user defined and is returned with Job status; can be used for correlating multiple jobs.</li> <li>Job Status shows summary totals of successful/failed/inserted/updated</li> <li>Added ability to retrieve failed entries via API call to <code>GET /api/v2/jobs/{id}/errors</code></li> <li>Job Status is added to Tenant Logs which allows a custom WebHook to be trigged using the WebHook Logs Extension</li> </ul> </p>",
		"old": false,
		"type": "added",
		"module": "Bulk Import",
		"exclusive": "",
		"team": [
			"hugo.arregui@auth0.com"
		],
		"publishedAt": "2016-08-05"
	},
	{
		"description": "<p>The Bitbucket Deployments extension allows you to deploy rules and database connection scripts from Bitbucket to Auth0. You can configure a Bitbucket repository, keep all your rules and database connection scripts there, and have them automatically deployed to Auth0 each time you push to your repository. <img src=\"https://cdn2.auth0.com/content/img/bitbucket-ext.png\" alt=\"extensions\"></p>",
		"old": false,
		"type": "added",
		"module": "Extensions",
		"exclusive": "cloud",
		"team": [
			"sandrino@auth0.com"
		],
		"publishedAt": "2016-08-01"
	},
	{
		"description": "<p>The <code>/authorize</code> endpoint now supports <code>response_mode=form_post</code> when the response_type is either <code>id_token</code> or <code>code token</code>.</p> <p>For example:<br> <code>/authorize?response_mode=form_post&client_id=…&redirect_uri=…&response_type=id_token</code></p>",
		"type": "added",
		"module": "Authentication",
		"exclusive": "",
		"old": false,
		"team": [
			"hernan.tierno@auth0.com"
		],
		"publishedAt": "2016-07-22"
	},
	{
		"description": "<p>Auth0 now supports full Client Credentials flow for API Authorizations. This allows server to server authorization for things like scripts, backend services, daemons, or any app that does not need to operate as a user.</p> <p>Enabling the API section can be done via Account Settings or by adding a new <strong>Non Interactive</strong> Client.</p> <p>The <strong>Application</strong> section in the Auth0 Dashboard has been renamed to <strong>Clients</strong> to clarify the distinction between APIs and Clients.</p> <p>This is the first step we are taking towards more complex API authorization scenarios. Other flows, such as User Consent, will be added in the near future. Please visit our full <a href='https://auth0.com/docs/api-auth'>documentation</a> for detailed information about API Authorization.</p>",
		"type": "added",
		"module": "API Authorization",
		"exclusive": "",
		"old": false,
		"team": [
			"jared@auth0.com",
			"martin.cabral@auth0.com",
			"yohanna.etchemendy@auth0.com",
			"tomas.chernov@auth0.com",
			"cristian@auth0.com",
			"matias@auth0.com"
		],
		"publishedAt": "2016-07-15"
	},
	{
		"description": "<p>Added password policy support for Password Dictionary and Password Personal Data.</p> <p><strong>Password Dictionary</strong>, when enabled, prevents the use of common passwords and allows for setting a custom dictionary with up to 200 entries.</p><p><strong>Password Personal Data</strong>, when enabled, prevents using personal data in the password, such as the user's name, parts of the email address, etc...</p>",
		"type": "added",
		"module": "Password Policy",
		"exclusive": "",
		"old": false,
		"team": [
			"eduardo.diaz@auth0.com",
			"jason.strutz@auth0.com",
			"alex@auth0.com"
		],
		"publishedAt": "2016-07-15"
	},
	{
		"description": "<p>Added ability to change Email for users in Passwordless connections.</p>",
		"type": "added",
		"module": "Connections: Passwordless",
		"exclusive": "",
		"old": false,
		"team": [
			"eduardo.diaz@auth0.com",
			"tomas.chernov@auth0.com",
			"jason.strutz@auth0.com"
		],
		"publishedAt": "2016-07-15"
	},
	{
		"description": "<p>Added support for Twillio Copilot in Passwordless Connections.</p>",
		"type": "added",
		"module": "Connections: Passwordless",
		"exclusive": "",
		"old": false,
		"team": [
			"hernan.tierno@auth0.com",
			"jason.strutz@auth0.com"
		],
		"publishedAt": "2016-07-14"
	},
	{
		"description": "<p>Support for Fitbit OAuth2 apps. Added an upgrade mechanism for OAuth1 (deprecated) connections.</p>",
		"type": "changed",
		"module": "Social Connections: Fitbit",
		"exclusive": "",
		"old": false,
		"team": [
			"eduardo.diaz@auth0.com",
			"jason.strutz@auth0.com",
			"jeff.smith@auth0.com"
		],
		"publishedAt": "2016-07-12"
	},
	{
		"description": "<p>If a user requests multiple passwordless links/codes, emails may not arrive or be displayed in the correct order. Up till now, only the last code issued was valid, causing issues when opening the wrong email. This change allows the last 5 codes sent to be valid, but once one is used, the rest are invalidated.</p>",
		"type": "Changed",
		"module": "Passwordless",
		"exclusive": "",
		"old": false,
		"team": [
			"hernan.tierno@auth0.com"
		],
		"publishedAt": "2016-07-02"
	},
	{
		"description": "<p>The GitHub Deployments extension allows you to deploy rules and database connection scripts from GitHub to Auth0. You can configure a GitHub repository, keep all your rules and database connection scripts there, and have them automatically deployed to Auth0 each time you push to your repository. <img src=\"https://cdn2.auth0.com/content/img/github-ext.png\" alt=\"extensions\"></p>",
		"old": false,
		"type": "added",
		"module": "Extensions",
		"exclusive": "cloud",
		"team": [
			"sandrino@auth0.com"
		],
		"publishedAt": "2016-06-29"
	},
	{
		"description": "<p>Added Password History support to Database Connections' password policies.</p>",
		"type": "added",
		"module": "Password Policy",
		"exclusive": "",
		"old": false,
		"team": [
			"hernan.tierno@auth0.com",
			"tomas.chernov@auth0.com",
			"yohanna.etchemendy@auth0.com",
			"jason.strutz@auth0.com",
			"alex@auth0.com"
		],
		"publishedAt": "2016-06-21"
	},
	{
		"description": "<p>Added support for the new Firebase SDK v3.</p>",
		"type": "added",
		"module": "Social Connections",
		"exclusive": "",
		"old": false,
		"team": [
			"martin@auth0.com",
			"eduardo.diaz@auth0.com"
		],
		"publishedAt": "2016-05-28"
	},
	{
		"description": "<p>Introduced a new tenant settings flag <code>enable_client_connections</code> that will allow customers to switch between 2 flows when creating clients (Applications): <ul> <li>When creating a new client, create and enable existing connections (current flow, default)</li> <li>When creating a new client, create but don't enable my existing connections (new flow)</li> </ul> </p> <p>This setting can be turned off in  Account Settings > Advanced > Settings > Enable Client Connections or via the API using the <code>GET /api/v2/tenants/settings</code> endpoint.<p>",
		"type": "added",
		"module": "Tenant Settings",
		"exclusive": "",
		"old": false,
		"team": [
			"cristian@auth0.com"
		],
		"publishedAt": "2016-05-25"
	},
	{
		"description": "<p>Webtasks improve the execution of rules and custom database logic. Webtasks perform much better than the current 'node sandbox' mode and provide much better isolation than the optional 'eval' mode. Webtasks have many more node.js modules available for your rule logic to use.</p>",
		"type": "added",
		"module": "Appliance",
		"exclusive": "Appliance",
		"old": false,
		"team": [
			"pablo.terradillos@auth0.com",
			"bob.brumfield@auth0.com",
			"silvio.massari@auth0.com",
			"chris@auth0.com"
		],
		"publishedAt": "2016-06-17",
		"release": "7247"
	},
	{
		"description": "<p>Search queries for users and transaction logs can execute on a secondary database instance. This reduces the load on the primary database node, ensuring that authentication transactions are not affected by expensive search queries in high load environments.</p>",
		"type": "added",
		"module": "Appliance",
		"exclusive": "Appliance",
		"old": false,
		"team": [
			"silvio.massari@auth0.com",
			"pablo.terradillos@auth0.com",
			"bob.brumfield@auth0.com",
			"chris@auth0.com"
		],
		"publishedAt": "2016-06-17",
		"release": "7247"
	},
	{
		"description": "<p>Auth0 now periodically collects aggregate statistics from appliance clusters. Customers can request a dump of the statistics collected.</p>",
		"type": "added",
		"module": "Appliance",
		"exclusive": "Appliance",
		"old": false,
		"team": [
			"bob.brumfield@auth0.com",
			"silvio.massari@auth0.com",
			"pablo.terradillos@auth0.com",
			"chris@auth0.com"
		],
		"publishedAt": "2016-06-17",
		"release": "7247"
	},
	{
		"description": "<p>Support for SSL offloading is now available. You can now configure the appliance to accept http. Your load balancer needs to provide a X-Forwarded-Proto header with this feature. The operational environment is responsible for ensuring http access is locked down to the load balancer.</p>",
		"type": "added",
		"module": "Appliance",
		"exclusive": "Appliance",
		"old": false,
		"team": [
			"chris@auth0.com",
			"pablo.terradillos@auth0.com",
			"bob.brumfield@auth0.com",
			"silvio.massari@auth0.com"
		],
		"publishedAt": "2016-06-17",
		"release": "7247"
	},
	{
		"description": "<p>The management dashboard can now use a different SSL certificate than the tenant authentication domains. With this feature you could for example run your authentication endpoints on externally facing domains while using an internal domain for the dashboard.</p>",
		"type": "added",
		"module": "Appliance",
		"exclusive": "Appliance",
		"old": false,
		"team": [
			"chris@auth0.com",
			"pablo.terradillos@auth0.com",
			"bob.brumfield@auth0.com",
			"silvio.massari@auth0.com"
		],
		"publishedAt": "2016-06-17",
		"release": "7247"
	},
	{
		"description": "<p>For queries that return a large number of results, the apiv2 user search endpoint will not return a count if a time limit for counting matching users is exceeded. Doing overall count queries, or count queries for a connection are efficient and will return results even when there are millions of users.</p>",
		"type": "fixed",
		"module": "Appliance",
		"exclusive": "Appliance",
		"old": false,
		"team": [
			"jose@auth0.com",
			"chris@auth0.com"
		],
		"publishedAt": "2016-06-17",
		"release": "7247"
	},
	{
		"description": "<p>The apiv1 user search endpoint caches results of a count operation for 5 minutes. The number of users should be considered an approximate count when doing search operations using apiv1.</p>",
		"type": "fixed",
		"module": "Appliance",
		"exclusive": "Appliance",
		"old": false,
		"team": [
			"jose@auth0.com",
			"chris@auth0.com"
		],
		"publishedAt": "2016-06-17",
		"release": "7247"
	},
	{
		"description": "<p>Performance of the management dashboard and user search improved. User search functionality is reduced as part of the performance improvement. You can now only sort users by email when doing a filtered search, and you can no longer sort by name or login count.</p>",
		"type": "changed",
		"module": "Appliance",
		"exclusive": "Appliance",
		"old": false,
		"team": [
			"silvio.massari@auth0.com",
			"bob.brumfield@auth0.com",
			"pablo.terradillos@auth0.com",
			"chris@auth0.com"
		],
		"publishedAt": "2016-05-28",
		"release": "6975"
	},
	{
		"description": "<p>The CLI backup capability has been enhanced. You now will designate a specific instance for backup from the CLI. This ensures a backup does not degrade your normal cluster operations during the process. Additionally you must now have a dedicated backup volume on the designated backup instance. This ensures that a backup will not fill up volumes used for normal operations.</p>",
		"type": "added",
		"module": "Appliance",
		"exclusive": "Appliance",
		"old": false,
		"team": [
			"silvio.massari@auth0.com",
			"bob.brumfield@auth0.com",
			"pablo.terradillos@auth0.com",
			"chris@auth0.com"
		],
		"publishedAt": "2016-05-20",
		"release": "6868"
	},
	{
		"description": "<p>A CSE can now configure an appliance cluster to distribute load over more cores to support scale up as an alternative to scale out. Some types of authentications require expensive cryptographic operations where scale up may be a more desirable approach.</p>",
		"type": "added",
		"module": "Appliance",
		"exclusive": "Appliance",
		"old": false,
		"team": [
			"silvio.massari@auth0.com",
			"bob.brumfield@auth0.com",
			"pablo.terradillos@auth0.com",
			"chris@auth0.com"
		],
		"publishedAt": "2016-05-20",
		"release": "6868"
	},
	{
		"description": "<p>Services are now periodically checked and restarted by an independent process. Typically services do restart automatically, alhtough in some unusual rapid failure modes a service may stop running. The monitoring service checks periodically for this condition and start any services that have failed their normal automatic restart. This additional monitoring function is off by default.</p>",
		"type": "added",
		"module": "Appliance",
		"exclusive": "Appliance",
		"old": false,
		"team": [
			"silvio.massari@auth0.com",
			"bob.brumfield@auth0.com",
			"pablo.terradillos@auth0.com",
			"chris@auth0.com"
		],
		"publishedAt": "2016-05-20",
		"release": "6868"
	},
	{
		"description": "<p>In this release a JSONP endpoint used for SSO has been disabled. This endpoint supported browsers before IE9. This exposes some potential vulnerabilities due to the weakness in the JSON protocol. A setting was also added that allows a customer to overrride the JSON disable on a per-tenant basis.</p>",
		"type": "added",
		"module": "Appliance",
		"exclusive": "Appliance",
		"old": false,
		"team": [
			"silvio.massari@auth0.com",
			"bob.brumfield@auth0.com",
			"pablo.terradillos@auth0.com",
			"chris@auth0.com"
		],
		"publishedAt": "2016-05-20",
		"release": "6868"
	},
	{
		"id": "56f1b43060cfa53624e6e92f",
		"description": "<p>Extensions gallery now supports documentation. From now on, you will be able to check documetion before and after installing an extension.</p>\n<p><img src=\"https://cdn2.auth0.com/content/img/extensions-docs.png\" alt=\"extensions\"> <img src=\"https://cdn2.auth0.com/content/img/extensions-docs4.png\"  alt=\"extensions\"></p>\n",
		"type": "added",
		"module": "Extensions",
		"exclusive": "cloud",
		"old": false,
		"team": [
			"javier.centurion@auth0.com",
			"victor@auth0.com",
			"maria@auth0.com"
		],
		"publishedAt": "2016-05-16"
	},
	{
		"description": "<p>Provided access to the language in passwordless email templates</p>\n",
		"type": "added",
		"module": "Passwordless emails",
		"exclusive": "",
		"old": false,
		"team": [
			"eduardo.diaz@auth0.com"
		],
		"publishedAt": "2016-05-12"
	},
	{
		"description": "<p>Added support for <strong>Bitbucket</strong> and <strong>Dropbox</strong> social connections.</p><p>If you are using <strong>Lock</strong>, please upgrade to <strong>v9.2.0</strong>.</p>\n",
		"type": "added",
		"module": "Social Connections: Bitbucket, Social Connections: Dropbox",
		"exclusive": "",
		"old": false,
		"team": [
			"gabriel@auth0.com",
			"victor@auth0.com",
			"richard.seldon@auth0.com"
		],
		"publishedAt": "2016-05-12"
	},
	{
		"description": "<p>Integrate Rules Debugging with Real-time Logs extension </p>\n<p><img src=\"https://cdn2.auth0.com/content/img/rule-debug.gif\" alt=\"extensions\"></p>\n",
		"type": "added",
		"module": "Rules",
		"exclusive": "cloud",
		"old": false,
		"team": [
			"javier.centurion@auth0.com"
		],
		"publishedAt": "2016-05-09"
	},
	{
		"description": "<p>We shipped 7 new logging extensions. You can now export Auth0 logs to one of the following external systems: </p>\n<p><ul><li>Auth0 Logs to Papertrail</li><li>Auth0 Logs to Sumologic</li><li>Auth0 Logs to Splunk</li><li>Auth0 Logs to Logstash</li><li>Auth0 Logs to Mixpanel</li><li>Auth0 Logs to Logentries</li></ul> <p>Export operation executes at configurable intervals to ensure you always have access to recent logs.</p> <img src=\"https://cdn2.auth0.com/content/img/logs-ext.png\" alt=\"extensions\"></p>\n",
		"type": "added",
		"module": "Extensions",
		"exclusive": "cloud",
		"old": false,
		"team": [
			"sandrino@auth0.com",
			"richard.seldon@auth0.com",
			"javier.centurion@auth0.com"
		],
		"publishedAt": "2016-05-08"
	},
	{
		"description": "<p>New Extension: Real-time Webtask Logs </p>\n<p>This extension gives you the possibility to access to Webtask Logs in real-time. <img src=\"https://cdn2.auth0.com/content/img/real-time-logs-1.png\" alt=\"extensions\"> <img src=\"https://cdn2.auth0.com/content/img/real-time-logs-2.png\" alt=\"extensions\"></p>\n",
		"type": "added",
		"module": "Extensions",
		"exclusive": "cloud",
		"old": false,
		"team": [
			"tomek@auth0.com",
			"javier.centurion@auth0.com"
		],
		"publishedAt": "2016-05-02"
	},
	{
		"description": "<p>New Extension: Authorization Dashboard </p>\n<p>This extension gives you the possibility to manage group memberships for your users.</p><h5>Group Management</h5><p>Allows you to create groups with a name and a description. Users can be added and removed from groups. This can happen by opening the group and managing users from there, or by opening the user and manage the user's group memberships from there.</p><p><img src=\"https://cdn2.auth0.com/content/img/authz-groups-ext.png\" alt=\"extensions\"></p>\n<h5>User Management</h5><p>Besides managing everything from the group point of view you can also open a user and manage his/her group memberships there but also see the \"calculated\" group memberships for that user.</p><p><img src=\"https://cdn2.auth0.com/content/img/authz-apps-ext.png\" alt=\"extensions\"></p>\n<h5>Application Access</h5><p>In Auth0 the application access is very coarse grained. All users in a connection that is enabled for the application are able to access the application. With this extension you are now able to take this a step further. You are able to define that only groups \"Fabrikam Management\" and \"Fabrikam Finance\" are able to access the \"Reporting App\" containing reports about the company's financials.</p><p><img src=\"https://cdn2.auth0.com/content/img/authz-users-ext.png\" alt=\"extensions\"></p>\n",
		"type": "added",
		"module": "Extensions",
		"exclusive": "cloud",
		"old": false,
		"team": [
			"sandrino@auth0.com",
			"javier.centurion@auth0.com"
		],
		"publishedAt": "2016-04-08"
	},
	{
		"description": "<p>Added logout <code>returnTo</code> URL validation. If the <code>returnTo</code> URL is not in the Allowed Logout URLs list, the request will be rejected. See the <a href=\"https://auth0.com/docs/logout#setting-allowed-logout-urls-at-the-account-level\">docs</a> for more information.</p>\n",
		"type": "added",
		"module": "Server",
		"exclusive": "",
		"release": "6576",
		"old": false,
		"team": [
			"hernan.tierno@auth0.com"
		],
		"publishedAt": "2016-04-22"
	},
	{
		"description": "<p>Remove support for JSONP on the <code>/ssodata</code> endpoint. The <i>&quot;Last time you logged in with&quot;</i> feature will no longer be supported on IE 9.</p>\n",
		"type": "removed",
		"module": "API",
		"exclusive": "",
		"old": false,
		"team": [
			"jose@auth0.com"
		],
		"publishedAt": "2016-05-10"
	},
	{
		"description": "<p>Added a new property on the <strong>client</strong> entity to allow users to specify how the client is going to perform authentication with the token endpoint. Values are <code>none</code>, <code>client_secret_post</code> and <code>client_secret_basic</code>. The <code>none</code> option is introduced for native applications which can’t store secrets and use <strong>PKCE</strong> (see <a href=\"https://tools.ietf.org/html/rfc7636\">https://tools.ietf.org/html/rfc7636</a>)</p>\n",
		"type": "added",
		"module": "Management API",
		"exclusive": "",
		"old": false,
		"team": [
			"martin.cabral@auth0.com"
		],
		"publishedAt": "2016-04-07"
	},
	{
		"description": "<p>Suppressed the error message in the change password flow in order to prevent user enumeration within the message. The API now returns HTTP 200.</p>\n",
		"type": "changed",
		"module": "Connections: Database",
		"exclusive": "",
		"old": false,
		"team": [
			"marcos.castany@auth0.com"
		],
		"publishedAt": "2016-04-06"
	},
	{
		"description": "<p>We included an extra validation in the <code>/tokeninfo</code> endpoint to verify that the account name in the URL matches the account for which the token was issued. Any call to the tokeninfo with a token from another account will return Unauthorized.</p>\n",
		"type": "fixed",
		"module": "Authentication API",
		"exclusive": "",
		"old": false,
		"team": [
			"iaco@auth0.com",
			"marcos.castany@auth0.com"
		],
		"publishedAt": "2016-04-06"
	},
	{
		"description": "<p>We deprecated the <code>current_user_device_credentials</code> scopes in the <code>/api/v2/device-credentials</code> endpoint for <code>POST</code> and <code>DELETE</code> methods. To use this endpoint we enabled <strong>Basic authentication</strong> with username and password from a database connection.</p>\n",
		"type": "deprecated",
		"module": "APIv2",
		"exclusive": "",
		"old": false,
		"team": [
			"iaco@auth0.com",
			"marcos.castany@auth0.com"
		],
		"publishedAt": "2016-04-05"
	},
	{
		"description": "<p>Users can now specify a list of URLs that are valid to redirect to after logging out from Auth0. The update can be done either from the <a href=\"https://manage.auth0.com/#/account/advanced\">Dashboard</a> or using the  <a href=\"https://auth0.com/docs/api/v2#!/Tenants/patch_settings\">Management API</a>.</p>\n",
		"type": "added",
		"module": "Dashboard / Management API",
		"exclusive": "",
		"release": "5970",
		"old": false,
		"team": [
			"hernan.tierno@auth0.com",
			"tomas.chernov@auth0.com",
			"cristian@auth0.com"
		],
		"publishedAt": "2016-03-15"
	},
	{
		"description": "<p>Added new <code>ext_nested_groups</code> option to <code>waad</code> connection strategy. When both <code>ext_groups</code> and <code>ext_nested_groups</code> are enabled we return all the groups that the user is a member of instead of only returning the ones that the user is direct member (for more information see this <a href=\"https://msdn.microsoft.com/Library/Azure/Ad/Graph/api/users-operations#UserFunctions\">MSDN article</a>)</p>\n",
		"type": "added",
		"module": "Enterprise Connections",
		"exclusive": "",
		"release": "5970",
		"old": false,
		"team": [
			"marcos.castany@auth0.com"
		],
		"publishedAt": "2016-03-15"
	},
	{
		"description": "<p>The <code>device-credentials</code> endpoint now supports basic authentication to perform <code>GET</code>, <code>POST</code>, and <code>DELETE</code> requests.</p>\n",
		"type": "added",
		"module": "Management API",
		"exclusive": "",
		"release": "5970",
		"old": false,
		"team": [
			"iaco@auth0.com",
			"marcos.castany@auth0.com"
		],
		"publishedAt": "2016-03-14"
	},
	{
		"description": "<p>Extensions Gallery updated! </p>\n<p>This new version allows you to create your own extensions. <img src=\"https://cdn2.auth0.com/content/img/extensions-custom.gif\" alt=\"extensions\"></p>\n",
		"type": "added",
		"module": "Extensions Gallery",
		"exclusive": "cloud",
		"old": false,
		"team": [
			"javier.centurion@auth0.com",
			"victor@auth0.com"
		],
		"publishedAt": "2016-03-11"
	},
	{
		"description": "<p>The flow to reset a password has been updated. </p>\n<p>In this new flow, users enter their username or email address and receive an email with instructions to choose a new password. The old flow which required users to enter their new password and then confirm the change via email is still available but has been deprecated: it is no longer available for new tenants and existing tenants are recommended to disable it.</p>\n",
		"type": "changed",
		"module": "Auth0 Lock v9",
		"exclusive": "",
		"release": "5970",
		"old": false,
		"team": [
			"iaco@auth0.com",
			"gabriel@auth0.com",
			"ricky@auth0.com",
			"benjamin@auth0.com"
		],
		"publishedAt": "2016-03-01"
	},
	{
		"description": "<p>Extensions Gallery updated.</p>\n<p>This new version gives users the possibility to search for an extension, easily check which ones are installed and access to more information about an extension before installing it. Also, includes new extensions such as <code>Auth0 logs to Loggly</code>, <code>Auth0 logs to Azure blob storage</code>, <code>Auth0 logs to Application Insights</code>, <code>Auth0 AD/LDAP Connector Health Monitor</code> and <code>Auth0 Authentication API webhooks</code> <img src=\"https://cdn2.auth0.com/content/img/extensions-new-design.png\" alt=\"extensions\"></p>\n",
		"type": "added",
		"module": "extensions",
		"exclusive": "cloud",
		"old": false,
		"team": [
			"javier.centurion@auth0.com",
			"victor@auth0.com"
		],
		"publishedAt": "2016-02-29"
	},
	{
		"description": "<p>Users can query logs using the <strong>Management API v2</strong>. </p>\n<p>You can use the new <code>logs</code> endpoints to query logs. This is the new recommended way to query logs. The <strong>API v1</strong> logs endpoints will still be functional. See more info in the <a href=\"https://auth0.com/docs/api/v2#!/Logs/get_logs\">docs</a>.</p>\n",
		"type": "added",
		"module": "Management API",
		"exclusive": "",
		"release": "5970",
		"old": false,
		"team": [
			"hernan.tierno@auth0.com"
		],
		"publishedAt": "2016-02-26"
	}
];


//////////////////
// WEBPACK FOOTER
// ./src/pages/changelog/changelog.json
// module id = 1111
// module chunks = 0